import { Callback } from 'src/util/query/models/Callback';

export class ResolveListForExportCallback<ListItem> extends Callback<ListItem[]> {
	public constructor(private readonly resolveList: (list: ListItem[] | null) => void) {
		super();
	}

	failureCallbackFunction = (failureResponse: unknown): void => {
		this.logFailureResponse(failureResponse);
		this.resolveList(null);
	};

	successCallbackFunction = (successResponse: ListItem[]): void => {
		this.resolveList(successResponse);
	};
}
